<template>
  <div :class="{ 'select-item-wrap': true, 'have-label': !!config.label }">
    <el-select
      class="select-item"
      v-model="value"
      clearable
      :placeholder="getLocaleText(config.placeholder || $t('placeholder.pleaseSelected{text}'),{text:''})"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
      <template #prefix>
        <div v-if="config.label" class="label-box"  >
          {{ getLocaleText(config.label) }}
        </div>
      </template>
    </el-select>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount, computed } from 'vue';
 
import { getTagsFormPlatform } from '@/api'; 
import useLocate from "./uses/useLocate.js";
import { useRenderConfig } from "./uses/useRenderConfig.js";
import { resolveBindDataKeyValue } from "@/utils/renderBinding";
// 定义 props
const props = defineProps({
  currentElementIndex: {
    type: Array,
    default: () => [],
  },
  idx: {
    type: Number,
    default: -1,
  },
  parentKeys: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  filterOption: {
    type: Function,
    default: () => true,
  },
  config: {
    type: Object,
  },
});

// 响应式数据
const value = ref('');
const options = ref([]);
const lastName = ref('');
let emit = defineEmits(["change"]);
const { bindData } = useRenderConfig(() => props.config);
const bindDefaultValue = computed(() => {
  return resolveBindDataKeyValue(
    bindData.value,
    props.config?.bindDataKey,
    '',
  );
});
// 计算属性
const currentElementIndexStr = computed(() => {
  return props.currentElementIndex && props.currentElementIndex.length
    ? props.currentElementIndex.join('x')
    : '';
});

let { langJson, nowLocale, getLocaleText } = useLocate();
 
// watch 监听
watch(
  () => props.config,
  (config) => {
    fetchFunc();
    if (config.name !== lastName.value) {
      if (!window.pageFields) {
        window.pageFields = {};
      }
      window.pageFields[config.name] = {
        setValue,
        getValue,
      };
      lastName.value = config.name;
      delete window.pageFields[lastName.value];
      delete window[`on${config.name}ValueChange`];
    }
  },
  { deep: true }
);

watch(value, (v) => {
  if (typeof window[`on${props.config.name}ValueChange`] === 'function') {
    window[`on${props.config.name}ValueChange`](v);
  }
  emit('change', v);
});

watch(
  bindDefaultValue,
  (nextValue) => {
    if (nextValue !== value.value) {
      value.value = nextValue;
    }
  },
  { immediate: true },
);

// 生命周期钩子
onMounted(() => {
  if (typeof window !== 'undefined') {
    fetchFunc();
    if (!window.pageFields) {
      window.pageFields = {};
    }
    lastName.value = props.config.name;
    window.pageFields[props.config.name] = {
      setValue,
      getValue,
    };
  }
});

onBeforeUnmount(() => {
  if (typeof window !== 'undefined' && window.pageFields) {
    delete window.pageFields[props.config.name];
  }
  delete window[`on${props.config.name}ValueChange`];
});

// 方法
const setValue = (v) => {
  value.value = v;
};

const getValue = () => {
  return value.value;
};

const fetchFunc = async (fetchData) => {
  try {
    let response = await getTagsFormPlatform( {
      parentParamCode: props.config.tagId,
      pageNo: 0,
      pageSize: 1000,
      ...fetchData,
    });

    options.value = response.data.dataList
      .filter((o) => props.filterOption(o))
      .map((o) => ({
        label: getLocaleText(o.paramDetailName),
        value: o.paramDetailCode,
      }));
  } catch (e) {
    console.error(e);
  }
};

</script>

<style scoped>
.select-item {
  width: 100%;
}
.label-box {
  margin-left: -5px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  height: 100%;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75px;
  font-size: 12px;
}
.have-label :deep(.el-input__inner) {
  padding-left: 100px;
}
</style>
